
import {Component, Vue} from 'vue-facing-decorator';
import * as API from "@/api";
import {closeWidget, redirect} from "@/utils";
import {setAuthLogin} from "@/api";
import {OpenDayTicketsData, OrderData, OpenDaySelectedTicket, OpenDayTicket} from "@/@types/api";
import "vue-router/dist/vue-router";
import {ValidateRules} from "@/@types/common";
import DocView from "@/views/DocView.vue";

@Component({
  components: {
    DocView
  }
})
export default class OpenDateProcess extends Vue {

  legalInfo = `Продавец:
АО «КРОКУС» ОГРН 1027700257023, Московская область, Красногорский район, г. Красногорск, ул. Международная, д. 18
`
  //Фонд «АТОМ» ИНН 9705164678 КПП 970501001 г. Москва, вн. тер. г. муниципальный округ Останкинский, пр-кт Мира, д. 119, стр
  // ООО «ГОРОДСКАЯ ФЕРМА» ИНН 7723381960 КПП 772301001 г. Москва, вн.тер.г. муниципальный округ Останкинский, пр-кт Мира, д. 1

  openDayTicketsData: OpenDayTicketsData | null = null

  closeDialog = false

  close = closeWidget

  //selectedLimit = 10

  orderData: OrderData | null = null
  payRedirectWindow = false // если false значит браузер блокирнул

  primaryColor = 'blue-lighten-1'

  conditionsAgree = false
  conditionsAlarm = false
  docDialog = false
  docUrl = ''
  docTitle = ''

  // загрузка общая
  pending = true

  // для календаря фильтр
  expositions = ''

  dialogPromo = false
  dialogPromoPending = false
  promoCode = ''
  promoCodeError = ''
  promo = ''
  promoTitle = ''
  logoName = ''
  source = ''
  mobile = false


  getPaymentProviderName() {
    return new URL(this.orderData?.pay_url ?? '')
  }

  onParentMessage(event) {

    if (event.data === 'vegasTicketWidget.clickOutside')
        // Закрываем без вопросов если выбранных билетов нет
      if (this.getTotalCount())
        this.closeDialog = true
      else
        this.close()
  }

  formatTimer(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // Форматируем минуты и секунды для отображения в формате 00:00
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  formatMoney(amount, digits = 0) {
    // Преобразуем число в строку и разделяем целую и десятичную части
    let parts = amount.toFixed(digits).toString().split('.');

    // Форматируем целую часть, добавляя разделители тысяч
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');  // 2009 тонкий , u00A0 обычный

    // Возвращаем отформатированную строку
    return parts.join('.') + '\xa0₽';
  }

  async mounted() {

    // this.svgHtml - будет undefined, получение определяем в update()

    window.addEventListener('message', this.onParentMessage)

  }

  beforeDestroy() {
    if (typeof window !== 'undefined')
      window.removeEventListener('message', this.onParentMessage)
  }

  async createOrder() {

    if (!this.conditionsAgree) {
      this.conditionsAlarm = true
      return;
    }

    this.step = 4

    try {
      const orderData = await API.createOnlineOrder({
        expo_tickets: this.selectedTickets,
        name: this.client.name,
        tel: this.client.tel.trim() ? "7" + this.client.tel.trim() : "",
        email: this.client.email,
        telegram: this.client.telegram,
        birthDate: this.client.birthDate,
        //sum: this.getTotalSum(),
        //ymClientId: Array.from(window.ymData.ids).join(',') + " " + window.ymData.clientId,
        promoCode: this.promoCode,
        promo: this.promo,
        source: this.source,
        comment: ""
      })

      this.orderData = orderData

      // для таймера сколько секунд осталось
      if (this.orderData?.paySeconds)
        setInterval(() => {
          if (this.orderData?.paySeconds) {
            this.orderData.paySeconds = this.orderData.paySeconds - 1
            if (this.orderData.paySeconds < 0)
              this.orderData.paySeconds = 0
          }
        }, 1000)

      if (this.orderData.pay_url == "success") {
        //this.$router.push('/success')
        this.step = 6
      } else {
        this.step = 5

        //this.ymAdd()

        // Если режим админа тогда показываем QR
        // if (this.$route.query['admin'])
        //   this.$router.push(`/qr?url=${encodeURIComponent(orderData.payUrl)}`)
        // // Если клиент, тогда перенаправляем на процессинг
        // else

        // работает - переделали на кнопку и показ таймера
        setTimeout(() => {
          if (this.orderData?.pay_url)
            this.payRedirectWindow = redirect(this.orderData.pay_url)
          if (this.payRedirectWindow)
            this.close()
        }, 100)

      }
      //this.step = 6
    } catch (e) {
      console.log(e)

      //this.$router.push('/fail?text=' + encodeURIComponent('Нам не удалось сформировать Ваш заказ. Пожалуйста повторите попытку.'))//this.step = 7
      this.showError('Нам не удалось сформировать Ваш заказ. Пожалуйста повторите позже.')
    }


  }

  dialogSellerInfo = false

  dialogPaymentRedirect = true

  getTotalSum = this.getSelectedSum

  getTotalCount = this.getSelectedCount

  onInputBirthDate(event: InputEvent) {

    // прибавили символ
    if (event.data) {
      if (this.client.birthDate.length === 2 || this.client.birthDate.length === 5)
        this.client.birthDate += '.'
      else if (this.client.birthDate.length > 10)
        this.client.birthDate = this.client.birthDate.slice(0, 10)
    }
    // // удалили символ
    else
      this.client.birthDate = ''

  }

  applyPromoCode() {

    return 1

  }

  async onSubmitClientForm() {

    const {valid} = await (this.$refs.clientForm as any).validate()

    if (valid) {
      this.step = 3

      if (this.$route.query['promocode'] as string) {
        this.promoCode = this.$route.query['promocode'] as string
        this.applyPromoCode()
      }

    }

  }

  client = {
    name: '',
    email: '',
    tel: '',
    birthDate: '',
    telegram: ''
  }

  showTel = true

  nameRules: ValidateRules = []

  emailRules: ValidateRules = []

  telRules: ValidateRules = []

  dateRules: ValidateRules = []

  step = 1

  errorText = ''

  showError(text = "") {
    this.errorText = text
    this.step = 7
  }

  openDoc(url: string, title = '') {
    this.docUrl = url
    this.docTitle = title
    this.docDialog = true
  }

  async created() {

    // можно вынести в App
    // пробуем получить родительский домен...
    setAuthLogin(window.location.hostname)

    this.telRules.push(value => {

      if (!value.trim()) return false;
      if (value.trim() && !/^\d+$/.test(value)) return 'Некорректный формат'

      return true

    })
    this.dateRules.push(value => {

      //if (/^\d{11}$/.test(value)) return true
      //this.client.error = !value// !/^\d+$/.test(value)

      if (!value.trim()) return false;

      // 25.12.2023
      if (value.trim() && !value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[0-9]|1[0-2])\.\d{4}$/)) return 'Некорректная дата'

      return true
    },)

    this.emailRules.push(value => {
      if (!value.trim()) return false;

      if (!/.+@.+\..+/.test(value))
        return 'E-mail некорректный'

      return true
    },)

    this.nameRules.push(value => {
      if (!value.trim()) return false;
      if (!/^[a-zA-Zа-яА-Я\s']+$/.test(value)) return 'Неверные символы'
      if (value?.length > 32) return 'Имя слишком длинное'

      return true
    })

    this.promo = this.$route.query['promo'] as string
    this.source = this.$route.query['source'] as string

    if (this.promo == 'evolution') {
      this.promoTitle = 'КОМБО-БИЛЕТ' // «ЭВОЛЮЦИЯ. ПУТЬ ПЛАНЕТЫ»
      this.expositions = '110,111'
      this.showTel = false
      this.logoName = 'logo_evo.png'
    }

    this.pending = true
    try {
      this.openDayTicketsData = await API.getOpenDateTickets(this.expositions)
    } catch (e) {
      this.step = 7
    } finally {
      this.pending = false
    }

  }

  toUserDate(date: string) {
    return (new Date(date)).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long', // "августа" (в родительном падеже)
      year: 'numeric'
    })
  }

  reloadPage() {
    if (typeof window !== 'undefined')
      window.location.reload()

  }

  selectedTickets: OpenDaySelectedTicket[] = []

  getSelectedTicketCount(ticket: OpenDayTicket) {
    let total = 0
    for (const ticketS of this.selectedTickets)
      if (this.isTicketsEqualSelected(ticket, ticketS))
        total += ticketS.count
    return total
  }

  getSelectedCount() {
    let total = 0
    for (const ticket of this.selectedTickets)
      total += ticket.count
    return total
  }

  getSelectedSum() {
    let total = 0
    for (const ticket of this.selectedTickets)
      total += ticket.price * ticket.count
    return total
  }

  isTicketsEqualSelected(ticket: OpenDayTicket, ticketS: OpenDaySelectedTicket): boolean {
    return ticket.exposition_id == ticketS.exposition_id
        && ticket.ticket_type_id == ticketS.ticket_type_id
        && ticket.price == ticketS.price
  }

  addTicket(ticket: OpenDayTicket, addCount: number) {

    if (addCount > 0 && this.getTotalCount() >= 10) return;

    for (let i = 0; i < this.selectedTickets.length; i++) {
      const ticketS = this.selectedTickets[i]
      if (this.isTicketsEqualSelected(ticket, ticketS)) {
        ticketS.count += addCount
        if (ticketS.count < 1) this.selectedTickets.splice(i, 1)
        return;
      }
    }

    // значит в цикл return не сработал добавляем новый элемент
    if (addCount > 0)
      this.selectedTickets.push({
        ...ticket,
        count: addCount,
        //date: this.date,
      })

  }

}

